import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useTrOOPSchedule from "./hooks/useTrOOPSchedule";

const TrOOPSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
  onNavigate,
}) => {
  const troopScheduleData = useTrOOPSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={troopScheduleData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {troopScheduleData.screen_title} -{" "}
          <span className="heading-cod">{troopScheduleData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={troopScheduleData.formFields}
        dropdownValues={troopScheduleData.dropdownValues}
        paramsData={troopScheduleData.paramsData}
        updataParamData={troopScheduleData.updateParamData}
        disabledDropdowns={troopScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={troopScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={troopScheduleData.selectMode}
        data={troopScheduleData.data}
        parmKey={troopScheduleData.parmKey}
        menuOptions={troopScheduleData.menuOptions}
        tableHeaders={troopScheduleData.columnDef}
        setRowData={troopScheduleData.setRowData}
        selectedPriceSchedules={troopScheduleData.selectedRows}
        setSelectedPriceSchedules={troopScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={troopScheduleData.first}
          rows={troopScheduleData.rows}
          totalRecords={troopScheduleData.totalRecords}
          currentPage={troopScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={troopScheduleData.onPageChange}
        />
      </div>
      {troopScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={troopScheduleData.isConfirmationModalOpen}
          onRequestClose={troopScheduleData.closeConfirmationModal}
          onBack={troopScheduleData.closeConfirmationModal}
          onSave={troopScheduleData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={troopScheduleData.setSelectedOption}
        />
      )}
      {troopScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={troopScheduleData.isHideConfirmationModalOpen}
          onRequestClose={troopScheduleData.closeHideConfirmationModal}
          onBack={troopScheduleData.closeHideConfirmationModal}
          onSave={troopScheduleData.hideUnhideTroopSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={troopScheduleData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default TrOOPSchedule;
